import { Typography } from 'antd';
import React, { useContext, useMemo } from 'react';

import Toggle from '../components/common/Toggle';
import CarrierDetail from '../components/panels/CarrierDetail';
import { AuthContext } from '../contexts/authContext';
import { useCarrierUpdate, useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierProfilePage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const carrierUpdateMutation = useCarrierUpdate();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const toggleCarrierActive = React.useCallback(() => {
    if (selectedCarrier) {
      carrierUpdateMutation.mutate({
        ...selectedCarrier,
        active: !selectedCarrier.active,
      });
    }
  }, [carrierUpdateMutation, selectedCarrier]);

  if (!selectedCarrier) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <div className="carrier-title">
        <Typography.Text>{selectedCarrier.name}</Typography.Text>
        {authUser?.role === UserRole.SUPER_ADMIN && (
          <Toggle
            defaultChecked={selectedCarrier.active}
            loading={carrierUpdateMutation.isLoading}
            size="small"
            onChange={toggleCarrierActive}
          />
        )}
      </div>

      <CarrierDetail carrier={selectedCarrier} id="profile" />
    </Layout>
  );
};

export default CarrierProfilePage;
